import {
  titleUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import SelectedFacility from '../../../components/FormFields/SelectedFacility';
import PageFieldSummary from '../../../components/PageFieldSummary';

export const pageTitle = 'Your school or training facility';
export const radioLabels = {
  Y: `Yes, save this facility for next time`,
  N: `No, I don't want to save this facility`,
};

// NOTE: Leaving useSchool as is for now so that SIP forms are not affected
const saveThisFacilityPage = {
  uiSchema: {
    ...titleUI(pageTitle),
    'ui:description': SelectedFacility,
    'ui:objectViewField': PageFieldSummary,
    useSchool: yesNoUI({
      title: 'Do you want to save this facility for next time?',
      hint: 'We can save this facility so it automatically prefills next time you use Ask VA.',
      labelHeaderLevel: '4',
      labels: radioLabels,
    }),
  },
  schema: {
    type: 'object',
    required: ['useSchool'],
    properties: {
      useSchool: yesNoSchema,
    },
  },
  title: pageTitle,
};

export default saveThisFacilityPage;
